"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

import { getSavedSlugsFromStorage } from "@/components/blog/BlogSaveArticleButton";
import { getPostMeta } from "@/lib/blog/posts";

export function SavedArticlesClient() {
  const [slugs, setSlugs] = useState<string[]>([]);

  useEffect(() => {
    const sync = () => setSlugs(getSavedSlugsFromStorage());
    sync();
    window.addEventListener("storage", sync);
    window.addEventListener("expirydesk-saved-change", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("expirydesk-saved-change", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  if (slugs.length === 0) {
    return (
      <p className="ed-blog-saved-empty">
        Nothing saved yet. Open any guide and tap <strong>Save article</strong>.
      </p>
    );
  }

  return (
    <ul className="ed-blog-saved-list">
      {slugs.map((slug) => {
        const m = getPostMeta(slug);
        if (!m) return null;
        return (
          <li key={slug} className="ed-blog-saved-card">
            <p className="ed-blog-saved-card__meta">
              {m.category} · {m.readingMinutes} min
            </p>
            <h2 className="ed-blog-saved-card__title">
              <Link href={`/blog/${slug}`}>{m.title}</Link>
            </h2>
            <p className="ed-blog-saved-card__desc">{m.description}</p>
          </li>
        );
      })}
    </ul>
  );
}
